import { render } from "./faq-hackathon.vue?vue&type=template&id=dcbdd5ee&scoped=true"
import script from "./faq-hackathon.vue?vue&type=script&lang=js"
export * from "./faq-hackathon.vue?vue&type=script&lang=js"

import "./faq-hackathon.vue?vue&type=style&index=0&id=dcbdd5ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcbdd5ee"]])

export default __exports__